var _defs, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlueSettingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9578",
    "data-name": "Group 9578",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#335089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5888ea"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3779",
    "data-name": "Path 3779",
    d: "M0,0H17V17H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3780",
    "data-name": "Path 3780",
    d: "M2.093,10.237a7.042,7.042,0,0,1,0-2.309A1.785,1.785,0,0,0,3.847,6.914a1.783,1.783,0,0,0-.524-1.957A7.042,7.042,0,0,1,4.957,3.323a1.785,1.785,0,0,0,1.958.524A1.783,1.783,0,0,0,7.927,2.093a7.042,7.042,0,0,1,2.311,0,1.784,1.784,0,0,0,1.013,1.755,1.783,1.783,0,0,0,1.957-.524,7.042,7.042,0,0,1,1.634,1.633,1.785,1.785,0,0,0-.524,1.958,1.783,1.783,0,0,0,1.755,1.013,7.042,7.042,0,0,1,0,2.311,1.784,1.784,0,0,0-1.755,1.013,1.783,1.783,0,0,0,.524,1.957,7.042,7.042,0,0,1-1.633,1.634,1.785,1.785,0,0,0-1.958-.524,1.783,1.783,0,0,0-1.013,1.755,7.042,7.042,0,0,1-2.311,0,1.784,1.784,0,0,0-1.013-1.755,1.783,1.783,0,0,0-1.957.524,7.042,7.042,0,0,1-1.634-1.633,1.785,1.785,0,0,0,.524-1.958,1.783,1.783,0,0,0-1.755-1.013Zm6.99.97A2.125,2.125,0,1,0,6.958,9.083,2.125,2.125,0,0,0,9.083,11.208Z",
    transform: "translate(-0.583 -0.583)",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueSettingIcon);
export default __webpack_public_path__ + "static/media/blueSettingIcon.8e6fea2906d38c5c743858c3bd7cf017.svg";
export { ForwardRef as ReactComponent };